import { LI, UL } from "../../../../../AbstractElements";

export const ProductColor = () => {
  return (
    <>
      <UL className="product-color simple-list flex-row">
        <LI className="bg-primary"></LI>
        <LI className="bg-secondary"></LI>
        <LI className="bg-success"></LI>
        <LI className="bg-info"></LI>
        <LI className="bg-warning"></LI>
      </UL>
      <hr />
    </>
  );
};
